import { PsOriginBase } from './PsOriginBase';

export class PsMachine extends PsOriginBase {

    _id; // number
    _name; // string
    _company; // PsCompany

    constructor(
        id,
        name,
    ) {
        super();
        this._id = id;
        this._name = name;
    }

    static fromAPIMachine(machine) {
        return new this(
            machine.id,
            machine.name || `${machine.brand} - ${machine.model}`,
        );
    }

    id() {
        return this._id;
    }

    name() {
        return this._name;
    }

    assignCompany(company) {
        this._company = company;
    }

    hasCompany() {
        return !!this._company;
    }

    companyId() {
        return this._company.id();
    }
}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/shared/model/PsMachine.js